import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import {GlobalCss} from 'components/global-css.js';
import {sessionState} from 'session/session-state.js';
import {FarmSelect} from 'components/FarmSelect.js';
import {ErrorMessage} from 'components/ErrorMessage.js';
import Button from '@material-ui/core/Button';
import {eartagAlertConfigAPI} from 'api/eartag-alert-config';
import {ErrorUtil} from 'utils/error-util.js';
import {ActionTable} from 'components/tables/ActionTable.js';
import {DateUtil} from 'utils/date-util.js';

const styles = {
  flexContainer: GlobalCss.flexContainer
};

const EartagAlertConfigIndex = (props) => {
  const {history, classes} = props;
  const [selectedFarmId, setSelectedFarmId] = useState(sessionState.currentFarmId());
  const [errorMessage, setErrorMessage] = useState('');
  const [records, setRecords] = useState([]);

  const columns = [
    {id: 'id', label: 'ID'},
    {id: 'alertType', label: 'アラート種別'},
    {id: 'suspendEndHour', label: '通知開始時間'},
    {id: 'suspendStartHour', label: '通知終了時間'},
    {id: 'enabled', label: '有効/無効', type: 'boolean'},
    {id: 'updatedAtDisplay', label: '更新日時'},
  ];

  useEffect(() => {
    if (!selectedFarmId) return;
    indexAction(selectedFarmId);
  }, [selectedFarmId]);

  const createAction = () => {
    const params = {
      pathname: '/eartag_alert_config/create',
    };
    history.push(params);
  };

  const updateAction = (record) => {
    const params = {
      pathname: `/eartag_alert_config/${record.id}/update`,
    };
    history.push(params);
  };

  const deleteAction = (record) => {
    const params = {
      pathname: `/eartag_alert_config/${record.id}/delete`,
    };
    history.push(params);
  };

  const indexAction = (farmId) => {
    return eartagAlertConfigAPI.index(farmId)
      .then((res) => {
        const records = (res.data || []).map((item) => {
          return {
            ...item,
            suspendStartHour: item.settings.suspendStartHour,
            suspendEndHour: item.settings.suspendEndHour,
            updatedAtDisplay: DateUtil.toYYYYMMDDHHmm(item.updatedAt),
            canUpdate: true,
            canDelete: true,
          };
        });

        setRecords(records);
      })
      .catch((error) => {
        setErrorMessage(ErrorUtil.generateMessage(error));
      });
  };

  const filterFunction = (farms) => {
    return farms.filter((farm) => farm.data.useSensorType !== 'use_neck_sensor');
  };

  return (
    <div style={{marginLeft: '20px'}}>
      <h2>[イヤタグ] アラート設定</h2>

      <div style={{marginLeft: '40px'}}>
        <ErrorMessage errorMessage={errorMessage} />
      </div>

      <ul className={classes.flexContainer} style={{marginBottom: 20}}>
        <li>
          <FarmSelect filterFunction={filterFunction} changeAction={() => {
            setSelectedFarmId(sessionState.currentFarmId());
          }
          }/>
        </li>

        <li style={{marginLeft: '100px'}}>
          <Button variant="contained" color="primary" onClick={createAction}>
            登録
          </Button>
        </li>
      </ul>

      <ActionTable
        records={records}
        columns={columns}
        updateAction={(record) => updateAction(record)}
        deleteAction={(record) => deleteAction(record)}
      />
    </div>
  );
};

EartagAlertConfigIndex.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    flexContainer: PropTypes.string.isRequired,
  }).isRequired,
};

const forExport = withRouter(withStyles(styles)(EartagAlertConfigIndex));
export {forExport as EartagAlertConfigIndex};
